// actions/index.js

export const saveResume = (resumeData) => ({
    type: 'SAVE_RESUME',
    payload: resumeData,
  });
  